import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography } from '@mui/material';
import { Trans } from 'react-i18next';

interface CopyHistoricLayoutDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const CopyHistoricLayoutDialog = ({ open, onCancel, onConfirm }: CopyHistoricLayoutDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle variant="dialogTitle" align="center">
        <Trans i18nKey="dashboard.copyHistoricLayout.title">Replace live dashboard?</Trans>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3, px: 3 }}>
        <Stack spacing={2}>
          <Typography variant="body1" component="p">
            <Trans i18nKey="dashboard.copyHistoricLayout.body">
              This will copy the current historic dashboard layout to your live dashboard. Your current live dashboard will be deleted. Are you sure
              you want to replace it?
            </Trans>
          </Typography>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'center', px: 2, py: 2 }}>
        <Stack direction="row" spacing={2}>
          <Button variant="text" onClick={onCancel}>
            <Trans i18nKey="button.cancel">Cancel</Trans>
          </Button>
          <Button variant="contained" color="primary" onClick={onConfirm}>
            <Trans i18nKey="button.replace">Replace</Trans>
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default CopyHistoricLayoutDialog;
